const FIELD_LABELS: Record<string, string> = {
  alias: 'Apelido',
  senha_certificado: 'Senha do certificado',
  arquivo: 'Arquivo',
  cpf: 'CPF',
  nome: 'Nome',
  numero: 'Número',
  uf: 'UF',
  id_tipo_documento: 'Tipo de documento',
  id_tipo_documento_principal: 'Tipo do documento principal',
  descricao: 'Descrição',
  tags: 'Tags',
};

const MSG_MAP: Record<string, string> = {
  'Field required': 'Campo obrigatório',
  'field required': 'Campo obrigatório',
  'Input should be a valid integer': 'Selecione uma opção válida',
  'Input should be a valid number': 'Valor inválido',
  'Input should be a valid string': 'Valor inválido',
  'Input should be a valid boolean': 'Valor inválido',
};

/**
 * Traduz a mensagem crua de validação para algo apresentável. Catch-all para o
 * vocabulário do Pydantic v2 ("Input should be ...") — nunca expor inglês
 * técnico ao usuário; mensagens já em PT (field_validator) passam direto.
 */
function cleanValidationMsg(rawMsg: string): string {
  if (MSG_MAP[rawMsg]) return MSG_MAP[rawMsg];
  if (/^Input should be\b/i.test(rawMsg)) return 'Valor inválido';
  return rawMsg;
}

export function parseValidationErrors(errors: Array<{ loc?: string[]; msg?: string }>): string {
  return errors
    .map((err) => {
      const field = err.loc?.slice(-1)[0] || '';
      // model_validator retorna loc=['body'] — não é um campo real
      if (!field || field === 'body' || field === '__root__') {
        const rawMsg = (err.msg || 'Dados inválidos').replace(/^Value error,\s*/i, '');
        return cleanValidationMsg(rawMsg);
      }
      const fieldName = FIELD_LABELS[field] || field;
      // Pydantic prefixa "Value error, " em mensagens de field_validator
      const rawMsg = (err.msg || 'Campo inválido').replace(/^Value error,\s*/i, '');
      const msg = cleanValidationMsg(rawMsg);
      // Evitar duplicação: "CPF: CPF inválido" → "CPF inválido"
      if (msg.toLowerCase().startsWith(fieldName.toLowerCase())) {
        return msg;
      }
      return `${fieldName}: ${msg}`;
    })
    .join('. ');
}
